import styled from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakpoints } from '~/src/features/tariffLines/styled';

export const Block = styled.div`
    margin-bottom: 60px;
    flex-direction: column;
    
    @media (max-width: ${breakpoints.mobile}) {
        width: 100%;
        margin-bottom: 32px;
    }
`;

export const BlockInfo = styled.div`
    flex-direction: column;
    gap: 16px;

    &:not(:last-child) {
        margin-bottom: 24px;
    }

    @media (max-width: ${breakpoints.mobile}) {
        gap: 8px;

        &:not(:last-child) {
            margin-bottom: 16px;
        }
    }
`;

// @todo use @r1-frontend/ui-react/typography
export const Title = styled.h2`
    ${FONTS.H2};
    
    @media (max-width: ${breakpoints.mobile}) {
        ${FONTS.H4};
    }
`;

// @todo use @r1-frontend/ui-react/typography
export const Text = styled.div`
    ${FONTS.L};
    
    @media (max-width: ${breakpoints.mobile}) {
        ${FONTS.XS};
    }
`;
